exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-af3dbfbe]{height:35px!important;line-height:35px;padding:0 30px 0 20px}", ""]);

// exports
